<div id="restrictionDetailsContainer" class="container fixed top-20 right-0 bottom-0 z-40 hiddenDetails cursor-default" [ngClass]="{ 'openDetails': restriction(), 'expanded': hasThreeColumns && expanded }">
  @if (restriction(); as restrictionDetail) {
    <section class="topbar h-14 mt-4 flex items-center">
      <div class="flex items-center ml-8 min-w-0">
        <img [src]="images.origin" alt="origin" class="h-4 w-4 mr-1.5 shrink-0" />
        <h1 [id]="'origin-' + restrictionDetail.originStop.id" class="text-xl font-semibold truncate" [tooltip]="utilsService.visibleTooltip('origin-' + restrictionDetail.originStop.id) ? (restrictionDetail.originStop.name ?? '') : ''" [visibleTooltip]="utilsService.visibleTooltip('origin-' + restrictionDetail.originStop.id)">{{ restrictionDetail.originStop.name }}</h1>
      </div>
      <app-input-search class="block h-9 ml-6 w-48 mr-2 shrink-0" [compact]="true" [width]="'full'" [searchValue]="searchTerm" [placeholder]="literalService.get('services.routes.design.fstop.searchPlaceholder', true)" (valueChangeEventEmitter)="onSearchChange($event)" (submitEventEmitter)="onSearchChange($event)"></app-input-search>
      <div id="actions" class="flex ml-auto mr-8 gap-2.5">
        <div class="flex items-center justify-center cursor-pointer content-image" (click)="toggleEditMode()" [tooltip]="literalService.get('services.routes.tooltips.edit', true)">
          <img [src]="images.services.edit" alt="edit" class="h-6 w-6" />
        </div>
        <div class="flex items-center justify-center cursor-pointer content-image" (click)="close()" [tooltip]="literalService.get('close', true)">
          <img [src]="images.close" alt="closeDetails" class="h-6 w-6" />
        </div>
      </div>
    </section>

    <section class="relative flex flex-col pl-8 pt-6 overflow-auto h-[calc(100%-72px)]" [ngClass]="hasThreeColumns ? 'pr-14' : 'pr-8'">
      @if (hasThreeColumns) {
        <div class="flex items-center absolute right-0 top-6 bottom-0 w-10 justify-center border-l neutrals-grey-02-border">
          <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer" [ngClass]="{ 'actionRotateArrowOpen': !expanded, 'actionRotateArrowClose': expanded }" (click)="toggleExpanded()" />
        </div>
      }
      <label class="flex items-center gap-1.5 font-semibold text-base mb-4 shrink-0">
        <img [src]="images.destination" alt="destination" class="h-4 w-4" />
        {{ restrictionsType() === RestrictionsType.BLACK_LIST
            ? literalService.get('services.routes.restrictions.headerDestinations.blackList', true)
            : literalService.get('services.routes.restrictions.headerDestinations.whiteList', true) }}
      </label>

      <div class="flex-1 overflow-y-auto overflow-x-hidden pb-6">
        <div class="grid gap-x-8 gap-y-3 content-start" [ngClass]="!hasThreeColumns ? 'grid-cols-2 w-full' : expanded ? 'grid-cols-3 w-full' : 'grid-cols-3 w-[calc(150%+1rem)]'">
          @for (destination of filteredDestinations; track destination.id) {
            <div class="flex items-center justify-between gap-2 py-1 min-w-0">
              <span [id]="'destination-' + destination.id" class="truncate text-base font-medium" [class.neutrals-grey-04-text]="markedForRemovalIds.has(destination.id!)" [tooltip]="utilsService.visibleTooltip('destination-' + destination.id) ? (destination.name ?? '') : ''" [visibleTooltip]="utilsService.visibleTooltip('destination-' + destination.id)">{{ destination.name }}</span>
              @if (editMode) {
                @if (markedForRemovalIds.has(destination.id!)) {
                  <div class="flex items-center justify-center cursor-pointer shrink-0 restore-icon" (click)="restoreDestination(destination)" [tooltip]="literalService.get('services.routes.restrictions.restore', true)">
                    <img [src]="images.services.restrictions.restore" alt="restore" class="h-4 w-4" />
                  </div>
                } @else {
                  <div class="flex items-center justify-center cursor-pointer shrink-0 remove-icon" (click)="removeDestination(destination)">
                    <img [src]="images.close" alt="remove" class="h-4 w-4" />
                  </div>
                }
              }
            </div>
          }
          @for (destination of filteredDestinationsToAdd; track destination.id) {
            <div class="flex items-center justify-between gap-2 py-1 min-w-0">
              <span [id]="'destination-add-' + destination.id" class="truncate text-base font-medium primary-purple-light-text" [tooltip]="utilsService.visibleTooltip('destination-add-' + destination.id) ? (destination.name ?? '') : ''" [visibleTooltip]="utilsService.visibleTooltip('destination-add-' + destination.id)">{{ destination.name }}</span>
              @if (editMode) {
                <div class="flex items-center justify-center cursor-pointer shrink-0 remove-icon" (click)="removeStagedDestination(destination)">
                  <img [src]="images.close" alt="remove" class="h-4 w-4" />
                </div>
              }
            </div>
          }
        </div>
      </div>

      @if (editMode) {
        <div class="flex justify-start my-10 gap-2 shrink-0">
          <input type="button" class="secondary gap-4 border-2 font-semibold h-10 w-30 uppercase cursor-pointer" [value]="literalService.get('cancel', true)" (click)="cancel()" />
          <input type="button" class="primary text-white gap-4 border-2 font-semibold h-10 w-30 uppercase cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed" [value]="literalService.get('save', true)" [disabled]="!hasChanges()" (click)="saveChanges()" />
        </div>
      }

      @if (restrictionDetail.creatorName || restrictionDetail.createdAt || restrictionDetail.modifierName || restrictionDetail.lastModifiedAt) {
        <div class="flex text-right justify-end items-end mt-auto pb-6 shrink-0">
          <div class="text-right">
            @if (restrictionDetail.creatorName || restrictionDetail.createdAt) {
              <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('created', true) }}
                @if (restrictionDetail.creatorName) {
                  <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ restrictionDetail.creatorName }}</span>
                }
                @if (restrictionDetail.createdAt) {
                  {{ literalService.get('at') }} {{ utilsService.convertDate(restrictionDetail.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
                }
              </p>
            }
            @if (restrictionDetail.modifierName || restrictionDetail.lastModifiedAt) {
              <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('lastModification', true) }}
                @if (restrictionDetail.modifierName) {
                  <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ restrictionDetail.modifierName }}</span>
                }
                @if (restrictionDetail.lastModifiedAt) {
                  {{ literalService.get('at') }} {{ utilsService.convertDate(restrictionDetail.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
                }
              </p>
            }
          </div>
        </div>
      }
    </section>
  }
</div>
